module.exports = __webpack_public_path__ + "src/assets/img/02.da23dafb.png";